import { render, staticRenderFns } from "./sealPointsInput.vue?vue&type=template&id=371b7e38&scoped=true"
import script from "./sealPointsInput.vue?vue&type=script&lang=js"
export * from "./sealPointsInput.vue?vue&type=script&lang=js"
import style0 from "./sealPointsInput.vue?vue&type=style&index=0&id=371b7e38&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371b7e38",
  null
  
)

export default component.exports